import { useGetPagesQuery } from "api/siteApi";
import { useEffect, useMemo } from "react";
import { getHostAndPath, normalizeUrl } from "utils/proxyUtils";
import { useAppDispatch, useAppSelector } from "../store";
import { getSelectedSiteId } from "../store/siteInfoSlice";
import { setIsLoadingAIDesignReview, setPageId } from "../store/tasksSlice";

const useGetPageId = () => {
    const siteId = useAppSelector(getSelectedSiteId);
    const dispatch = useAppDispatch();
    const { data, isLoading, isSuccess } = useGetPagesQuery(
        { siteId: siteId || '' },
        { skip: !siteId }
    );

    const pageId = useMemo(() => {
        if (isSuccess && data?.data?.pages?.page) {
            const page = data.data.pages.page?.find(
                (p) => {
                    const url = !window.ATARIM
                        ? normalizeUrl(p.target_url)
                        : normalizeUrl(p.iframe_url);

                    const url1 = getHostAndPath(url);
                    const url2 = getHostAndPath(window.location.href);
                    return url1?.fullPath === url2?.fullPath;
                }
            );
            if (page?.design_review_is_running) {
                dispatch(setIsLoadingAIDesignReview({ page_id: page.id, status: 'running' }));
            }
            return page?.id;
        }
        return null;
    }, [isSuccess, data, dispatch]);

    const currentPage = useMemo(() => {
        if (isSuccess && data?.data?.pages?.page) {
            return data.data.pages.page?.find(
                (p) => {
                    const url = !window.ATARIM
                        ? normalizeUrl(p.target_url)
                        : normalizeUrl(p.iframe_url);

                    const url1 = getHostAndPath(url);
                    const url2 = getHostAndPath(window.location.href);
                    return url1?.fullPath === url2?.fullPath;
                }
            );
        }
        return null;
    }, [isSuccess, data]);

    // Update the slice with the pageId when it changes
    useEffect(() => {
        if (pageId) {
            dispatch(setPageId(pageId));
        }
    }, [pageId, dispatch]);

    return {
        data,
        pageId,
        isLoading,
        isSuccess,
        currentPage
    };
}

export default useGetPageId;